import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
declare const ga: Function;

const { enabled, trackingId, trackerConfig } = environment.ga;

@Injectable()
export class GAService {
  constructor() {
    if (enabled) {
      ga('create', trackingId, trackerConfig);
    }
  }

  trackPageView() {
    if (enabled) {
      ga('send', 'pageview');
    }
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/services/ga.service.ts